import React, { useState, useEffect, useRef } from 'react';
import Grid from '@material-ui/core/Grid';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import UseFetchData from "../../../hooks/UseFetchData";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import Moment from 'moment';

const UserCreate = (props) => {
    const [Mode, setMode] = useState('');
    const [EmpName, setEmpName] = useState('');
    const [UserName, setUserName] = useState('');
    const [UserPassword, setUserPassword] = useState('');
    const [UserType, setUserType] = useState('');
    const [IsActive, setIsActive] = useState('');
    const [CreatedByID, setCreatedByID] = useState(sessionStorage.UserName);
    const [CreatedOn, setCreatedOn] = useState(Moment(new Date()).format("YYYY-MM-DD"));
    const [ModifiedByID, setModifiedByID] = useState(sessionStorage.UserName);
    const [ModifiedOn, setModifiedOn] = useState(Moment(new Date()).format("YYYY-MM-DD"));
    const [response, fetchData] = UseFetchData();
    const [responseGetData, fetchGetData] = UseFetchData('');
    const [ComboDataResponse, fetchComboData] = UseFetchData();
    const [UserTypecmb, setUserTypecmb] = useState([]);
    const { value, onChange, ...rest } = props;
    const [cursor, setCursor] = useState(null);
    const ref = useRef(null);

    const UserTypeOptions = [
        { key: 'Admin', value: 'Admin' },
        { key: 'Engineer', value: 'Engineer' }
    ]


    // const validationSchema = Yup.object({


    //     UserName: Yup.string().required('Required!'),
    //     UserPassword: Yup.string().required('Required!'),
    //     UserType: Yup.string().required('Required!'),
    //     IsActive: Yup.string().required('Required!')

    // });


    useEffect(() => {
        const input = ref.current;
        if (input) input.setSelectionRange(cursor, cursor);
    }, [ref, cursor, value]);

    const handleChange = (e) => {
        // setCursor(e.target.selectionStart);
        onChange && onChange(e);
    };


    const onSubmit = values => {
        setMode('Insert');
        var IsActive = '';
        if (values.IsActive === 'Y') {
            IsActive = 'Y';
        }
        else {
            IsActive = 'N';
        }
        var UpdatedByID = sessionStorage.UID;
        var bodyFormData = new FormData();
        bodyFormData.append("UserID", props.UserID);
        bodyFormData.append("UserName", values.UserName);
        bodyFormData.append("UserPassword", values.UserPassword);
        bodyFormData.append("UserType", values.UserType);
        bodyFormData.append("CreatedByID", sessionStorage.UID);
        bodyFormData.append("CreatedOn", values.CreatedOn);
        bodyFormData.append("ModifiedByID", sessionStorage.UID);
        bodyFormData.append("ModifiedOn", values.ModifiedOn);
        bodyFormData.append("IsActive", IsActive);
        fetchData("User/Save", bodyFormData);
    };
    const IsActiveOptions = [
        { key: 'Yes', value: 'Y' },
        { key: 'No', value: 'N' }
    ]




    useEffect(() => {
        if (response.Response === true) {
            alert('Data Saved Succesfully.');
            props.setOpen(false);
            props.PopulateData();
        }
        else if (response.Response === false) {
            if (response.Message.includes('Already') === true) {
                alert(response.Message);
            }
            else {
                alert('Failed.');
            }
        }
        if (props.UserID !== '') {
            setMode('Update');
        }
        else {
            setMode('Insert');
        }
        if (response.length > 0 && Mode === 'Update') {
            var isActive = '';
            if (response[0].IsActive === "Y") {
                isActive = 'Y';
            }
            else {
                isActive = 'N';
            }

            setUserName(response[0].UserName);
            setUserPassword(response[0].UserPassword);
            setUserType(response[0].UserType);
            debugger;

            setIsActive(isActive);
        }
    }, [response]);

    const getByIDData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("UserID", props.UserID);
        bodyFormData.append("UserPassword", UserPassword);
        fetchGetData("User/GetByID", bodyFormData);
    }

    useEffect(() => {
        if (responseGetData.length > 0) {
            setUserName(responseGetData[0].UserName);
            setUserType(responseGetData[0].UserType);
            setUserPassword(responseGetData[0].UserPassword);
            setIsActive(responseGetData[0].IsActive);
        }
    }, [responseGetData])

    useEffect(() => {

        if (props.UserID !== '') {
            setMode('Update');
            getByIDData();
        }
        else {
            setMode('Insert');
        }

    }, [])

    const GetComboData = () => {
        var bodyFormData = new FormData();
        fetchComboData("User/ComboData", bodyFormData);

    };

    const UserTypeData = () => {
        let UserTypeCombo = UserTypeOptions.map((data) => (
            <option key={data.key} value={data.value}>
                {data.key}
            </option>
        ));
        return UserTypeCombo;
    };


    // useEffect(() => {
    //     if (ComboDataResponse !== undefined) {
    //         if (ComboDataResponse["UserType"] !== undefined) {
    //             UserTypData(ComboDataResponse["UserType"]);

    //             // if (props.UserID !== '') {
    //             //     setMode('Update');
    //             //     GetUserData();
    //             // }
    //             // else {
    //             //     setMode('Insert');
    //             // }
    //         }
    //     }
    // }, [ComboDataResponse]);

    useEffect(() => {
        GetComboData();
        //UserTypData();
    }, [])

    // const GetUserData = () => {
    //     var bodyFormData = new FormData();
    //     bodyFormData.append("UserID", props.UserID);
    //     //fetchData("User/GetByID", bodyFormData);
    //     fetchData("User/Save", bodyFormData);
    // };
    // const GetComboData = () => {
    //     //fetchComboData("User/ComboData");
    //     fetchComboData("/");
    // };

    let UserTypeCombo = UserTypeData();

    return (
        <div>
            <Formik initialValues={{
                UserName: UserName, UserPassword: UserPassword, UserType: UserType, IsActive: IsActive, CreatedByID: CreatedByID, CreatedOn: CreatedOn, ModifiedByID: ModifiedByID, ModifiedOn: ModifiedOn
            }}
                // validationSchema={validationSchema} 
                onSubmit={onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid spacing={1} container>
                            <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
                                <Grid item xs={2}>
                                    <label
                                        htmlFor={"UserName"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"User Name"}
                                    </label>
                                </Grid>
                                <Grid item xs={4} >
                                    <BiztranControlsFormik
                                        autoFocus="autofocus"
                                        control="input"
                                        type="text"
                                        name="UserName"
                                        ref={ref}
                                        value={UserName}
                                        //options={ASIcmb}                   
                                        onChange={(e) => {
                                            setUserName(e.target.value)
                                            handleChange()
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={2} style={{ paddingLeft: 30 }}>
                                    <label
                                        htmlFor={"password"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Password"}
                                    </label>
                                </Grid>
                                <Grid item xs={4} >
                                    <BiztranControlsFormik
                                        autoFocus="autofocus"
                                        control="input"
                                        type="Password"
                                        name="UserPassword"
                                        ref={ref}
                                        value={UserPassword}
                                        // options={RMcmb}                   
                                        onChange={(e) => {
                                            setUserPassword(e.target.value)
                                            handleChange()
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
                                <Grid item xs={2}>
                                    <label
                                        htmlFor={"CreatedByID"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Created By"}
                                    </label>
                                </Grid>
                                <Grid item xs={4} >
                                    <BiztranControlsFormik
                                        autoFocus="autofocus"
                                        control="input"
                                        type="text"
                                        name="CreatedByID"
                                        ref={ref}
                                        value={CreatedByID}
                                        disabled={true}
                                        //options={ASIcmb}                   
                                        onChange={(e) => {
                                            setCreatedByID(e.target.value)
                                            handleChange()
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={2} style={{ paddingLeft: 30 }}>
                                    <label
                                        htmlFor={"CreatedOn"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Created On"}
                                    </label>
                                </Grid>
                                <Grid item xs={4} >
                                    <BiztranControlsFormik
                                        autoFocus="autofocus"
                                        control="input"
                                        type="text"
                                        name="CreatedOn"
                                        ref={ref}
                                        value={CreatedOn}
                                        disabled={true}
                                        // options={RMcmb}                   
                                        onChange={(e) => {
                                            setCreatedOn(e.target.value)
                                            handleChange()
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
                                <Grid item xs={2}>
                                    <label
                                        htmlFor={"ModifiedByID"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Modified By"}
                                    </label>
                                </Grid>
                                <Grid item xs={4} >
                                    <BiztranControlsFormik
                                        autoFocus="autofocus"
                                        control="input"
                                        type="text"
                                        name="ModifiedByID"
                                        ref={ref}
                                        value={ModifiedByID}
                                        //options={ASIcmb} 
                                        disabled={true}
                                        onChange={(e) => {
                                            setModifiedByID(e.target.value)
                                            handleChange()
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={2} style={{ paddingLeft: 30 }}>
                                    <label
                                        htmlFor={"ModifiedOn"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Modified On"}
                                    </label>
                                </Grid>
                                <Grid item xs={4} >
                                    <BiztranControlsFormik
                                        autoFocus="autofocus"
                                        control="input"
                                        type="text"
                                        name="ModifiedOn"
                                        ref={ref}
                                        value={ModifiedOn}
                                        disabled={true}
                                        // options={RMcmb}                   
                                        onChange={(e) => {
                                            setModifiedOn(e.target.value)
                                            handleChange()
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
                                <Grid item xs={2}>
                                    <label
                                        htmlFor={"UserType"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"User Type"}
                                    </label>
                                </Grid>
                                <Grid item xs={4} >
                                    <BiztranControlsFormik
                                        autoFocus="autofocus"
                                        control="select"
                                        type="text"
                                        name="UserType"
                                        ref={ref}
                                        // value={UserType}
                                        options={UserTypeCombo}
                                        onChange={(e) => {
                                            setUserType(e.target.value)
                                            handleChange()
                                        }}
                                    />
                                </Grid>

                            </Grid>

                            <Grid item xs={12} >
                                <BiztranControlsFormik
                                    control='radio'
                                    label='IsActive'
                                    name='IsActive'
                                    options={IsActiveOptions}
                                    onChange={(e) => { setIsActive(e.target.value) }}
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            startIcon={<SaveIcon />}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => { props.setOpen(false); }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
}

export default UserCreate;
